import type { ReactNode } from 'react';
import { cn } from './ui-x';

/**
 * Client pages are wider than the talent ones — the reference's client screens
 * are dashboards and data tables, not reading pages. Default is the spec's
 * `mx-auto max-w-7xl`; `detail` and `narrow` step down for drill-downs and
 * forms.
 */
export type PageWidth = 'wide' | 'detail' | 'narrow';

const WIDTHS: Record<PageWidth, string> = {
  wide: 'max-w-7xl',
  detail: 'max-w-5xl',
  narrow: 'max-w-3xl',
};

type Props = {
  width?: PageWidth;
  /** Dashboards breathe at space-y-8; every other page is space-y-6. */
  dashboard?: boolean;
  className?: string;
  children: ReactNode;
};

/**
 * The page wrapper. <main> pays the padding (see Layout), so this only owns
 * the width constraint and the vertical rhythm — never re-apply page padding
 * here or on a page.
 */
const PageShell = ({ width = 'wide', dashboard, className, children }: Props) => (
  <div
    className={cn(
      'mx-auto w-full',
      dashboard ? 'space-y-8' : 'space-y-6',
      WIDTHS[width],
      className
    )}
  >
    {children}
  </div>
);

export default PageShell;
